/** Shared portfolio data for home preview + projects page */
export const portfolioProjects = [
  {
    id: 8,
    title: 'POS SaaS Platform',
    categoryLabel: 'POS / SaaS',
    filter: 'POS',
    platform: 'Flutter App + Web',
    description:
      'Cloud point-of-sale for retail — sales, inventory, parties, purchases, reports, multi-currency, 47+ languages, and offline sync.',
    icon: 'fas fa-cash-register',
    tech: ['Flutter', 'Laravel', 'Firebase', 'SaaS'],
    gradient: 'linear-gradient(160deg, #0e6b3c 0%, #6dbb1a 45%, #1e3a5f 100%)',
    links: { live: 'https://pos.rhutechsolutions.com/' },
    category: 'pos',
    featured: true,
    isProduct: true,
    location: 'India & UK',
    domain: 'pos.rhutechsolutions.com',
    previewImage: '/projects/pos-saas.jpg',
  },
  {
    id: 6,
    title: 'Education LMS Platform',
    categoryLabel: 'LMS / EdTech',
    filter: 'LMS',
    platform: 'Web App + Mobile',
    description:
      'Complete learning platform — exams, courses, live classes, AI study plans, certificates, shop, chat, and full admin control panel.',
    icon: 'fas fa-graduation-cap',
    tech: ['Laravel', 'React', 'JWT', 'FCM', 'AI'],
    gradient: 'linear-gradient(160deg, #0e6b3c 0%, #1e3a5f 55%, #0f172a 100%)',
    links: {
      live: 'https://mintcream-mouse-380540.hostingersite.com/',
      detail: '/lms',
    },
    category: 'lms',
    featured: true,
    isProduct: true,
    detailPath: '/lms',
    domain: 'mintcream-mouse-380540.hostingersite.com',
    location: 'India & UK',
    previewImage: '/projects/education-lms-live.jpg',
  },
  {
    id: 7,
    title: 'Times Book Stall',
    categoryLabel: 'E-commerce',
    filter: 'E-commerce',
    platform: 'WooCommerce Store',
    description:
      'Competitive exam books shop for APPSC, TGPSC, UPSC, SSC, RRB & more — category browsing, wishlist, compare, and INR checkout.',
    icon: 'fas fa-book',
    tech: ['WordPress', 'WooCommerce', 'India'],
    gradient: 'linear-gradient(160deg, #b45309 0%, #0e6b3c 50%, #1e3a5f 100%)',
    links: { live: 'https://timesbookstall.in/' },
    category: 'web',
    featured: true,
    location: 'Hyderabad, India',
    domain: 'timesbookstall.in',
    previewImage: '/projects/times-book-stall.jpg',
  },
  {
    id: 1,
    title: 'Norfolk Daily Fresh',
    categoryLabel: 'E-commerce',
    filter: 'E-commerce',
    platform: 'WooCommerce Store',
    description:
      'Online grocery & international food market for Norwich — categories, weekly deals, delivery, and secure checkout.',
    icon: 'fas fa-shopping-basket',
    tech: ['WordPress', 'WooCommerce', 'UK'],
    gradient: 'linear-gradient(160deg, #166534 0%, #22c55e 45%, #0e6b3c 100%)',
    links: { live: 'https://norfolkdailyfresh.com/' },
    category: 'web',
    featured: true,
    location: 'Norwich, UK',
    domain: 'norfolkdailyfresh.com',
    previewImage: '/projects/norfolk-daily-fresh.jpg',
  },
  {
    id: 2,
    title: 'iTech Norwich',
    categoryLabel: 'Business Website',
    filter: 'Websites',
    platform: 'Service & Booking Site',
    description:
      'Phone, tablet & laptop repair centre — services, reviews, device trade-in quotes, and contact funnels for Norwich customers.',
    icon: 'fas fa-tools',
    tech: ['WordPress', 'SEO', 'Lead Forms'],
    gradient: 'linear-gradient(160deg, #0e6b3c 0%, #1e3a5f 55%, #334155 100%)',
    links: { live: 'https://itechnorwich.com/' },
    category: 'web',
    featured: true,
    location: 'Norwich, UK',
    domain: 'itechnorwich.com',
    previewImage: '/projects/itech-norwich.jpg',
  },
  {
    id: 3,
    title: 'Gift Kart Store',
    categoryLabel: 'E-commerce',
    filter: 'E-commerce',
    platform: 'WooCommerce',
    description: 'Gift card marketplace with secure checkout and product management.',
    icon: 'fas fa-gift',
    tech: ['WordPress', 'WooCommerce'],
    gradient: 'linear-gradient(160deg, #0e6b3c 0%, #6dbb1a 100%)',
    links: { live: 'https://giftkartstore.com' },
    category: 'web',
    featured: true,
    domain: 'giftkartstore.com',
    previewImage: '/projects/gift-kart-store.jpg',
  },
  {
    id: 4,
    title: 'OpenRide UK',
    categoryLabel: 'Ride Sharing',
    filter: 'Mobile Apps',
    platform: 'React & Node.js',
    description: 'Real-time ride booking, tracking, and secure payments.',
    icon: 'fas fa-car',
    tech: ['React', 'Node.js', 'MongoDB'],
    gradient: 'linear-gradient(160deg, #1e293b 0%, #0e6b3c 100%)',
    links: { live: 'https://openride.co.uk/' },
    category: 'mobile',
    featured: true,
    domain: 'openride.co.uk',
    previewImage: '/projects/openride-uk.jpg',
  },
  {
    id: 5,
    title: 'Ascrit Technologies',
    categoryLabel: 'Corporate',
    filter: 'Websites',
    platform: 'Laravel Web App',
    description: 'IT services website with portfolio and lead capture.',
    icon: 'fas fa-building',
    tech: ['Laravel', 'MySQL', 'Bootstrap'],
    gradient: 'linear-gradient(160deg, #6dbb1a 0%, #f2b705 100%)',
    links: { live: 'https://www.ascrit.in/' },
    category: 'web',
    featured: true,
    domain: 'ascrit.in',
    previewImage: '/projects/ascrit.jpg',
  },
];

export const portfolioFilters = ['All', 'LMS', 'POS', 'Websites', 'E-commerce', 'Mobile Apps'];

function sortFeaturedFirst(list) {
  return [...list].sort((a, b) => {
    if (a.isProduct && !b.isProduct) return -1;
    if (!a.isProduct && b.isProduct) return 1;
    return Number(b.featured) - Number(a.featured);
  });
}

export function filterPortfolioProjects(filter) {
  if (filter === 'All') return sortFeaturedFirst(portfolioProjects);
  return portfolioProjects.filter((p) => p.filter === filter);
}

/** All projects with a working live URL */
export function getLivePortfolioProjects() {
  return sortFeaturedFirst(
    portfolioProjects.filter((p) => p.links?.live && p.links.live !== '#')
  );
}

export const liveProjectsCount = getLivePortfolioProjects().length;

/** Homepage + portfolio: show every project (no limit) */
export function getHomePortfolioProjects(filter) {
  return filterPortfolioProjects(filter);
}
